// Thank-you tier ladder. A creator's total thanks received drives their tier.
// `waves` = number of scallops on the seal portal ring; `amp` = wave height.
// Casual stays nearly circular (few small waves); ranks add more, taller waves.
export const TIERS = [
    { name: "Casual", min: 0, color: "#9ca3af", waves: 4, amp: 2.5 },
    { name: "Regular", min: 100, color: "#22c55e", waves: 5, amp: 3.5 },
    { name: "Dedicated", min: 1000, color: "#2196f3", waves: 6, amp: 4 },
    { name: "Super", min: 10000, color: "#a855f7", waves: 8, amp: 4.5 },
    { name: "Hardcore", min: 100000, color: "#f97316", waves: 10, amp: 5 },
    { name: "Die Hard", min: 1000000, color: "#ef4444", waves: 11, amp: 5 },
    { name: "Legendary", min: 10000000, color: "#facc15", waves: 12, amp: 5.5 },
];

export function tierFor(count = 0) {
    const c = Number(count) || 0;
    let t = TIERS[0];
    for (const x of TIERS) if (c >= x.min) t = x;
    return t;
}

export function nextTier(count = 0) {
    const c = Number(count) || 0;
    return TIERS.find((x) => x.min > c) || null;
}
